import React from "react";
import Popup from "../../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import GroupEntityMultiInput from "../../Helpers/MultiInput/GroupEntityMultiInput";
import trans from "../../../utils";

export default function GroupsConnectionPopup({ groupId, groupName, onClose }) {
	return (
		<Popup show={!!groupId} size="xl" style="popup-bodyscroll">
			<Modal.Header className="modal-header flex-between">
				<Modal.Title id="contained-modal-title-vcenter">
					<PopupTitle
						headtitle={groupName}
						subtitle={trans("Connect or link this group to other modules.")}
					/>
				</Modal.Title>
				<Close
					// eslint-disable-next-line react/style-prop-object
					style="close-32 close"
					close={onClose}
					img="Close"
				/>
			</Modal.Header>
			<Modal.Body className="modal-body-scrollable">
				<GroupEntityMultiInput
					label="Geofence"
					styling="mb-3"
					groupId={groupId}
					entityType="geofence"
				/>
				<GroupEntityMultiInput
					label="Notification"
					styling="mb-3"
					groupId={groupId}
					entityType="notification"
				/>
				<GroupEntityMultiInput
					label="Driver"
					styling="mb-3"
					groupId={groupId}
					entityType="driver"
				/>
				<GroupEntityMultiInput
					label="Maintenance"
					styling="mb-3"
					groupId={groupId}
					entityType="maintenance"
				/>
			</Modal.Body>
		</Popup>
	);
}
